module.exports = __webpack_public_path__ + "static/winterwarmer-a2302f50a174adcf957491a474c581f0.jpeg";